import { useQuery } from "react-query"
import { getVisitNotesReportData } from "./visitNotesReportApi"

export const useGetVisitNotesReportDataQuery = (startDate?: string, endDate?: string) => {
  return useQuery(['visitNotesReport', startDate, endDate], {
    queryFn: () => getVisitNotesReportData(startDate, endDate),
    refetchOnWindowFocus: false
  })
}